export const useMoney = () => {
  function format(amount: number, currency: string) {
    const money = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency,
    });
    return money.format(amount / 100);
  }

  return { format };
};
